import React, { memo } from "react";
import { AnswerManLaboSurvey } from "./AnswerManLaboSurvey";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { useExtractRestaurantIdFromUrl } from "../../../hooks/externalApi/line/useExtractRestaurantIdFromUrl";
import { LiffLoginProcess } from "../../organisms/LiffLoginProcess";
import { Navigate } from "react-router-dom";
import { useSwrNoAuth } from "../../../hooks/swr/useSwrNoAuth";


export const ManLaboLiffApp: React.FC = memo(() => {
  const restaurantId = useExtractRestaurantIdFromUrl();

  // Hook は常に呼ぶ（restaurantId が null の場合は SWR がスキップ）
  const { data: existingAnswer, isLoading: isLoadingAnswer, error: answerError } = useSwrNoAuth<any>(
    restaurantId ? `manzokudo_labo/survey/answers/customer/?restaurant_id=${restaurantId}` : null
  );

  // 以降で条件分岐して UI を返す
  if (restaurantId === null || isLoadingAnswer) {
    return <CircularLoading />;
  }

  const isNotAnswered = answerError?.response?.status === 404 || existingAnswer == null;
  if (!isNotAnswered) {
    return <Navigate replace to={"/thanks"} />;
  }

  return (
    <LiffLoginProcess restaurantId={restaurantId} liffType="manzokudolabo">
      <AnswerManLaboSurvey restaurantId={restaurantId} />
    </LiffLoginProcess>
  );
});